import { toast } from "react-toastify"
import CircleExclamation from "../assets/images/icons/circle-exclamation-white.svg"

const Message = ({ title, body }) => (
    <div className="toast-notification-text-block">
      <p className="title">{title}</p>
      <p className="body">{body}</p>
    </div>
  )

export const showToastError = ({title, body}) => {
    toast.error(<Message title={title} body={body}/>, {
        icon: ({theme, type}) =>  <img src={CircleExclamation}/>,
        style: {backgroundColor: '#DB2828', padding: '0px'},
        bodyClassName: "toast-notification-content",
    });
}

export const showToastSuccess = ({title, body}) => {
    toast.error(<Message title={title} body={body}/>, {
        icon: ({theme, type}) =>  <img src={CircleExclamation}/>,
        style: {backgroundColor: '#1A5100', padding: '0px'},
        bodyClassName: "toast-notification-content",
    });
}